import {
  CHANGE_NOTIFICATION_SETTINGS,
  GET_BRANDS,
  GET_CURRENT_SUB,
  GET_PLANS,
  LOGIN_USER,
  SET_ACTIVE_ACCOUNT,
  SET_ALERT_DETAILS,
  SET_BRAND_DETAILS,
  SET_EDIT_DRAFT_DATA,
  SET_EDIT_POST_DATA,
  SET_LOGGED_IN,
  SET_REDIRECT_URL,
  SET_SCHEDULE_DATA,
  SET_TIMEZONES,
  SET_USER,
  SET_USER_ACCOUNTS,
  SHOW_NOTIFICATIONS_BADGE,
  SHOW_DMS_BADGE,
  SHOW_COMMENTS_BADGE,
  SET_NEW_NOTIFICATION,
  TOGGLE_SIDEBAR,
  SET_PAGE_TITLE,
  RESET,
  SET_MEMBER,
  GET_MEMBERS,
  GET_INVITES,
  SET_NEW_POST_STATUS,
  SET_NEW_CONVERSATIONS,
} from "./actions/types";

import axios from "axios";
import { initialState } from "./rootReducer";
import { showAlert } from "utils/utils";
import { store } from "./store";

export const axiosInstance = axios.create({
  baseURL: initialState.api_host,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

export const authService = () => {
  axiosInstance.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      const token = store.getState().user_token;
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (error.response.status === 401) {
        setLoggedIn(false);
      }

      return Promise.reject(error);
    }
  );
};

export const registerUser = async (data) => {
  let res;
  try {
    res = await axiosInstance.post(`register`, data);

    if (res.data.status === true) {
      store.dispatch({
        type: LOGIN_USER,
        payload: res.data.data,
      });

      const user_profiles_storage = localStorage.getItem("user_profiles");
      const allUsers = user_profiles_storage
        ? { ...JSON.parse(user_profiles_storage) }
        : {};
      const { user, token, refresh_token } = res.data.data;
      allUsers[user.email] = { ...user, token, refresh_token };

      localStorage.setItem("user_profiles", JSON.stringify(allUsers));

      await getTimezones();
    }
  } catch (e) {
    throw Error(e.response.data?.message);
  }

  return res;
};

export const loginUser = async (data) => {
  let res;

  try {
    res = await axiosInstance.post(`login`, data);

    if (res.data.status === true) {
      const values = res.data.data.user;
      const rmCheck = document.getElementById("rememberMe");

      if (rmCheck.checked && values.email !== "") {
        localStorage.username = values.email.trim();
        localStorage.checkbox = rmCheck.value;
      } else {
        localStorage.username = "";
        localStorage.checkbox = "";
      }

      store.dispatch({
        type: LOGIN_USER,
        payload: res.data.data,
      });

      const user_profiles_storage = localStorage.getItem("user_profiles");
      const allUsers = user_profiles_storage
        ? { ...JSON.parse(user_profiles_storage) }
        : {};
      const { user, token } = res.data.data;
      allUsers[user.email] = { ...user, token };

      localStorage.setItem("user_profiles", JSON.stringify(allUsers));

      await getUserAccounts();
      await getTimezones();
    }

    return res;
  } catch (e) {
    return e.response;
  }
};

export const resendVerificationEmail = async (data) => {
  let res;

  try {
    res = await axiosInstance.post(`email/verification-notification`, data);
  } catch (e) {
    throw Error(e.response.data?.message);
  }

  return res;
};

export const socialLogin = async (provider, search) => {
  let res;

  try {
    res = await axiosInstance.get(`auth/${provider}/callback${search}`);

    if (res.data.status === true) {
      store.dispatch({
        type: LOGIN_USER,
        payload: res.data.data,
      });

      const user_profiles_storage = localStorage.getItem("user_profiles");
      const allUsers = user_profiles_storage
        ? { ...JSON.parse(user_profiles_storage) }
        : {};
      const { user, token } = res.data.data;
      allUsers[user.email] = { ...user, token };

      localStorage.setItem("user_profiles", JSON.stringify(allUsers));

      await getUserAccounts();
      await getTimezones();
    }

    return res;
  } catch (e) {
    return e.response;
  }
};

export const createUserAccount = async (data) => {
  let res;

  try {
    res = await axiosInstance.post(`account`, data);
  } catch (e) {
    throw Error(e.response.data?.message);
  }

  return res;
};

export const getUser = async () => {
  try {
    let res = await axiosInstance.get(`user`);

    if (res.data.status === true) {
      const user = res.data.data;
      const user_profiles_storage = localStorage.getItem("user_profiles");
      const allUsers = user_profiles_storage
        ? { ...JSON.parse(user_profiles_storage) }
        : {};
      allUsers[user.email] = user;

      localStorage.setItem("user_profiles", JSON.stringify(allUsers));

      store.dispatch({
        type: SET_USER,
        payload: res.data.data,
      });
    }
  } catch (e) {
    console.log(e);
  }
};

export const getUserAccounts = async () => {
  const accountId = localStorage.getItem("account_id");
  const currentAccountList = store.getState().user_accounts;

  try {
    const res = await axiosInstance.get(`account`);

    if (res?.data?.status === true) {
      const { data: accounts } = res.data;
      const account1 = accounts[0];
      const tempAccount = accounts.find(
        (item) => item.id === parseInt(accountId)
      );

      const accountsDifference = [];
      
      for (const item of accounts) {
        if (!currentAccountList?.find(acc => acc.id === item?.id)) {
          accountsDifference.push(item);
        }
      }

      const newAccount = accountsDifference[0];

      store.dispatch({
        type: SET_USER_ACCOUNTS,
        payload: accounts,
      });

      if (newAccount) {
        store.dispatch({
          type: SET_ACTIVE_ACCOUNT,
          payload: newAccount,
        });
      }
      else if (tempAccount) {
        store.dispatch({
          type: SET_ACTIVE_ACCOUNT,
          payload: tempAccount,
        });
      } 
      else {
        store.dispatch({
          type: SET_ACTIVE_ACCOUNT,
          payload: account1,
        });
      }
    }
    await getMember();
    await getMembers();
    await getUser();
    await getBrands();

    return res;
  } catch (e) {
    console.log(e);
    return e.response
  }
};

export const setOnboardingViewedStatus = async () => {
  try {
    await axiosInstance.get(`viewedTooltips`);
  } catch (e) {
    console.log(e);
    showAlert({
      msg: "An error occurred. Try again later.",
      type: "danger",
    });
  }
};

export const updateProfile = async (data) => {
  try {
    let res = await axiosInstance.post(`EditProfile`, data);

    return res;
  } catch (e) {
    console.log(e);
  }
};

export const changePassword = async (data) => {
  try {
    let res = await axiosInstance.post(`ChangePassword`, data);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getTimezones = async () => {
  try {
    let res = await axiosInstance.get(`timezone`);

    if (res.data.status === true) {
      store.dispatch({
        type: SET_TIMEZONES,
        payload: res.data.data,
      });
    }
  } catch (e) {
    console.log(e);
  }
};

export const createBrand = async (data) => {
  const accountId = store.getState().active_account?.id;
  let res;

  try {
    res = await axiosInstance.post(`account/${accountId}/brands`, data);

    if (res.data.status === true) {
      store.dispatch({
        type: SET_BRAND_DETAILS,
        payload: res.data.data,
      });
    }

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getBrands = async (page = 1) => {
  const accountId = store.getState().active_account?.id;
  const activeBrand = store.getState().brand;

  let res;
  try {
    res = await axiosInstance.get(`account/${accountId}/brands?page=${page}`);

    if (res.data.status === true) {
      const { brands } = res.data.data;

      const newActiveBrand = brands.find(
        (brand) => brand?.id === activeBrand?.id
      );

      if (newActiveBrand) {
        getBrand(newActiveBrand.id);
      }

      store.dispatch({
        type: GET_BRANDS,
        payload: brands,
      });

      if (brands.length && !newActiveBrand) {
        store.dispatch({
          type: SET_BRAND_DETAILS,
          payload: brands[0],
        });
      }

      if (!brands.length) {
        store.dispatch({
          type: SET_BRAND_DETAILS,
          payload: null,
        });
      }
    }
  } catch (e) {
    console.log(e.response);
    return e.response;
  }

  return res;
};

export const getBrand = async (id) => {
  const brandId = parseInt(id);
  const accountId = store.getState().active_account?.id;
  const activeBrand = store.getState().brand;

  try {
    let res = await axiosInstance.get(`account/${accountId}/brands/${brandId}`);

    if (res.data.status === true) {
      if (!activeBrand || brandId === activeBrand?.id) {
        store.dispatch({
          type: SET_BRAND_DETAILS,
          payload: res.data.data,
        });
      }
    }

    return res;
  } catch (e) {
    return e.response;
  }
};

export const updateBrand = async (data, brandId) => {
  const accountId = store.getState().active_account?.id;
  let res;

  data.append("_method", "PUT");

  try {
    res = await axiosInstance.post(
      `account/${accountId}/brands/${brandId}`,
      data
    );

    if (res?.data?.status === true) {
      await getBrand(brandId);
    }

    return res;
  } catch (e) {
    return e.response;
  }
};

export const deleteBrand = async (brandId) => {
  const accountId = store.getState().active_account?.id;
  let res;

  try {
    res = await axiosInstance.delete(`account/${accountId}/brands/${brandId}`);
    return res;
  } catch (e) {
    return e.response;
  }
};

export const getSocials = async (brandId) => {
  const accountId = store.getState().active_account?.id;
  const url = `account/${accountId}/brands/${brandId}/socials`;

  try {
    let res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const removeSocialMediaAccount = async (data) => {
  const { platform, brandId, id } = data;
  let res;

  try {
    res = await axiosInstance.delete(`${platform}/${brandId}/delete/${id}`);
    return res;
  } catch (e) {
    return e.response;
  }
};

export const uploadMedia = async (fileList) => {
  const brandId = store.getState().brand?.id;
  const url = `brand/${brandId}/medias`;
  const uploads = new FormData();

  for (const file of fileList) {
    uploads.append("media[]", file);
  }

  try {
    let res = await axiosInstance.post(url, uploads);
    return res;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const uploadDMsMedia = async (fileList) => {
  const brandId = store.getState().brand?.id;
  const url = `brand/${brandId}/medias/dm`;
  const uploads = new FormData();

  for (const file of fileList) {
    uploads.append("media[]", file);
  }

  try {
    let res = await axiosInstance.post(url, uploads);
    return res;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const createPost = async (data) => {
  const { accountId, brandId, post, gmt_offset } = data;
  const url = `account/${accountId}/brand/${brandId}/posts`;

  try {
    let res = await axiosInstance.post(url, { post, gmt_offset });

    if (res?.data?.status === true) {
      await getBrand(brandId);
    }
    return res;
  } catch (e) {
    throw e;
  }
};

export const editPost = async (postId, data) => {
  const accountId = store.getState().active_account?.id;
  const brandId = store.getState().brand?.id;
  const post = data[0];
  const url = `account/${accountId}/brand/${brandId}/posts/${postId}`;

  try {
    let res = await axiosInstance.post(url, { ...post, _method: "PUT" });
    return res;
  } catch (e) {
    throw e;
  }
};

export const deletePost = async (postId) => {
  const accountId = store.getState().active_account?.id;
  const brandId = store.getState().brand?.id;
  const url = `account/${accountId}/brand/${brandId}/posts/${postId}`;

  try {
    let res = await axiosInstance.delete(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getPosts = async (accountId, brandId, category, page = 1) => {
  if (!brandId) return;
  const url = `account/${accountId}/brand/${brandId}/posts?${category}=true&page=${page}`;

  try {
    let res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getPost = async (postId) => {
  const accountId = store.getState().active_account?.id;
  const brandId = store.getState().brand?.id;
  const url = `account/${accountId}/brand/${brandId}/posts/${postId}`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const createDraft = async (data) => {
  const { brandId, draft } = data;
  const url = `brand/${brandId}/drafts`;

  try {
    let res = await axiosInstance.post(url, { draft });
    return res;
  } catch (e) {
    throw e;
  }
};

export const editDraft = async (draftId, data) => {
  const brandId = store.getState().brand?.id;
  const url = `brand/${brandId}/drafts/${draftId}`;

  try {
    let res = await axiosInstance.post(url, { ...data, _method: "PUT" });
    return res;
  } catch (e) {
    throw e;
  }
};

export const approveDraft = async (draftId, schedule_date) => {
  const brandId = store.getState().brand?.id;
  const url = `brand/${brandId}/drafts/${draftId}/approve`;

  try {
    let res = await axiosInstance.post(url, { schedule_date });
    return res;
  } catch (e) {
    throw e;
  }
};

export const deleteDraft = async (draftId) => {
  const brandId = store.getState().brand?.id;
  const url = `brand/${brandId}/drafts/${draftId}`;

  try {
    let res = await axiosInstance.delete(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getAllConversations = async (platforms) => {
  const brandId = store.getState().brand?.id;
  const url = `brands/${brandId}/dms${
    platforms ? `?platform=${JSON.stringify(platforms)}` : ""
  }`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getAllConversationMessages = async (conversationId) => {
  const brandId = store.getState().brand?.id;
  const url = `brands/${brandId}/conversation/${conversationId}/dms`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const sendDirectMessage = async (conversationId, data) => {
  const brandId = store.getState().brand?.id;
  const url = `brands/${brandId}/conversation/${conversationId}/dms`;

  try {
    const res = await axiosInstance.post(url, data);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getAllComments = async (params) => {
  const brandId = store.getState().brand?.id;
  const url = `brand/${brandId}/comments`;

  try {
    const res = await axiosInstance.post(url, params);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getPostComments = async (platform, postId) => {
  const brandId = store.getState().brand?.id;
  const url = `${platform}/brand/${brandId}/${postId}/comments`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const createPostComment = async (platform, postId, comment) => {
  const brandId = store.getState().brand?.id;
  const url = `${platform}/brand/${brandId}/comments`;

  try {
    const res = await axiosInstance.post(url, { comment, post_id: postId });

    return res;
  } catch (e) {
    return e.response;
  }
};

export const replyPostComment = async (platform, commentId, message) => {
  const brandId = store.getState().brand?.id;
  const url = `${platform}/brand/${brandId}/comments/${commentId}`;

  try {
    const res = await axiosInstance.post(url, { message });

    return res;
  } catch (e) {
    return e.response;
  }
};

export const deletePostComment = async (platform, commentId) => {
  const brandId = store.getState().brand?.id;
  const url = `${platform}/brand/${brandId}/comments/${commentId}`;

  try {
    const res = await axiosInstance.delete(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getCommentReplies = async (platform, commentId) => {
  const brandId = store.getState().brand?.id;
  const url = `${platform}/brand/${brandId}/comments/${commentId}`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getAllContentAnalytics = async (socials, query) => {
  const brandId = store.getState().brand?.id;
  if (!brandId) return;

  const url = `/brands/${brandId}/socials/contents/analytics${
    query ? `?${query}` : ""
  }`;

  try {
    const res = await axiosInstance.post(url, { socials });

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getAllAccountAnalytics = async (socials, query) => {
  const brandId = store.getState().brand?.id;
  if (!brandId) return;

  const url = `/brands/${brandId}/socials/channel/analytics${
    query ? `?${query}` : ""
  }`;

  try {
    const res = await axiosInstance.post(url, { socials });

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getPlatformAccountAnalytics = async (
  platform,
  query = "start_date=2023-05-20&end_date=2023-06-20"
) => {
  const brandId = store.getState().brand?.id;
  if (!brandId) return;

  const url = `${platform}/brand/${brandId}/analytics${
    query ? `?${query}` : ""
  }`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getAudienceAnalytics = async (
  platform,
  query = "start_date=2023-05-20&end_date=2023-06-20"
) => {
  const brandId = store.getState().brand?.id;
  if (!brandId) return;

  const url = `${platform}/brand/${brandId}/audience/analytics${
    query ? `?${query}` : ""
  }`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getCalendarEvents = async (query) => {
  const brandId = store.getState().brand?.id;
  if (!brandId) return;

  const url = `brand/${brandId}/calendar${query ? `?${query}` : ""}`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getInstagramGridData =async()=> {
  const accountId = store.getState().active_account?.id;
  const brandId = store.getState().brand?.id;

  const url = `account/${accountId}/brand/${brandId}/insta-grids`;
  try {
    let res = await axiosInstance.get(url);
    return res;
  } catch (e) {
    throw e;
  }
}

export const reorderInstagramGrid =async(data)=> {
  const accountId = store.getState().active_account?.id;
  const brandId = store.getState().brand?.id;

  const url = `account/${accountId}/brand/${brandId}/insta-grids/re-order`;
  try {
    let res = await axiosInstance.post(url, data);
    return res;
  } catch (e) {
    throw e;
  }
}

export const getPlans = async () => {
  try {
    const res = await axiosInstance.get(`plans`);

    if (res.data.status === true) {
      store.dispatch({
        type: GET_PLANS,
        payload: res.data.data.plans,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const getBillingHistory = async (page) => {
  try {
    const res = await axiosInstance.get(`payments?page=${page}`);
    console.log(res);
    return res;
  } catch (e) {
    return e.response;
  }
};

export const subscribe = async (accountId, planId) => {
  let res;

  try {
    res = await axios.post(
      `${initialState.api_host}payment/${accountId}/new-subscribe/${planId}`,
      {}
    );

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getCurrentSub = async () => {
  try {
    let res = await axiosInstance.get(`currentSubscription`);

    if (res.data.status === true) {
      store.dispatch({
        type: GET_CURRENT_SUB,
        payload: res.data.sub,
      });
    } else if (res.data.status === false) {
      store.dispatch({
        type: GET_CURRENT_SUB,
        payload: null,
      });
    }
  } catch (e) {
    console.log(e);
  }
};

export const getAllNotifications = async () => {
  const accountId = store.getState().active_account?.id;
  const url = `account/${accountId}/notifications`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const getNotificationSettings = async () => {
  const accountId = store.getState().active_account?.id;
  const url = `account/${accountId}/notification-setting`;

  try {
    const res = await axiosInstance.get(url);

    return res;
  } catch (e) {
    return e.response;
  }
};

export const updateNotificationSettings = async (id, data) => {
  const url = `setting/${id}/notification-setting`;

  try {
    const res = await axiosInstance.post(url, { ...data, _method: "PUT" });

    return res;
  } catch (e) {
    return e.response;
  }
};

export const helpCenter = async (data) => {
  let res;

  try {
    res = await axiosInstance.post(`help-center`, data);
  } catch (e) {
    return e.response;
  }

  return res;
};

export const changeCharacterLimitsNotificationStatus = async () => {
  let res;

  try {
    res = await axiosInstance.get(`viewed_allowed_chars`);

    if (res?.data?.status === true) {
      getUser();
    }
  } catch (e) {
    return e.response;
  }

  return res;
};

export const setEditPostData = (data) => {
  store.dispatch({
    type: SET_EDIT_POST_DATA,
    payload: data,
  });
};

export const setEditDraftData = (data) => {
  store.dispatch({
    type: SET_EDIT_DRAFT_DATA,
    payload: data,
  });
};

export const setScheduleData = (data) => (dispatch) => {
  dispatch({
    type: SET_SCHEDULE_DATA,
    payload: data,
  });
};

export const setBrandDetails = (data) => (dispatch) => {
  dispatch({
    type: SET_BRAND_DETAILS,
    payload: data,
  });
};

export const changeNotificationSettings = (data) => (dispatch) => {
  dispatch({
    type: CHANGE_NOTIFICATION_SETTINGS,
    payload: data,
  });
};

export const setRedirectUrl = (url) => (dispatch) => {
  dispatch({
    type: SET_REDIRECT_URL,
    payload: url,
  });
};

export const setAlertDetails = (data) => {
  store.dispatch({
    type: SET_ALERT_DETAILS,
    payload: data,
  });
};

export const setNewPostStatus = (data) => {
  store.dispatch({
    type: SET_NEW_POST_STATUS,
    payload: data,
  });
};

export const setNewNotification = (data) => {
  store.dispatch({
    type: SET_NEW_NOTIFICATION,
    payload: data,
  });
};

export const showNotificationsBadge = (status) => {
  store.dispatch({
    type: SHOW_NOTIFICATIONS_BADGE,
    payload: status,
  });
};

export const setNewConversations = (data) => {
  store.dispatch({
    type: SET_NEW_CONVERSATIONS,
    payload: data,
  });
};

export const showDmsBadge = (status) => {
  store.dispatch({
    type: SHOW_DMS_BADGE,
    payload: status,
  });
};

export const showCommentsBadge = (status) => {
  store.dispatch({
    type: SHOW_COMMENTS_BADGE,
    payload: status,
  });
};

export const setPageTitle = (title) => {
  store.dispatch({
    type: SET_PAGE_TITLE,
    payload: title,
  });
};

export const setLoggedIn = (status) => {
  if (!status) {
    // const reportIssuePrompt = localStorage.getItem("reportIssuePrompt");
    // const username = localStorage.getItem("username");
    // const checkbox = localStorage.getItem("checkbox");
    // const accountId = localStorage.getItem("account_id");
    const user_profiles_storage = localStorage.getItem("user_profiles");
    const user_profiles = user_profiles_storage
      ? { ...JSON.parse(user_profiles_storage) }
      : {};
    const user = store.getState().user;

    user && delete user_profiles[user.email];

    store.dispatch({ type: RESET });

    // localStorage.clear();

    // localStorage.setItem("reportIssuePrompt", reportIssuePrompt);
    // localStorage.setItem("username", username);
    // localStorage.setItem("checkbox", checkbox);
    // localStorage.setItem("account_id", accountId);
    // localStorage.setItem("user_profiles", JSON.stringify(user_profiles));
  }

  store.dispatch({
    type: SET_LOGGED_IN,
    payload: status,
  });
};

export const setActiveAccount = (data) => {
  store.dispatch({
    type: SET_ACTIVE_ACCOUNT,
    payload: data,
  });
};

export const setUserAccount = (email) => (dispatch) => {
  const user_profiles_storage = localStorage.getItem("user_profiles");
  const user_profiles = user_profiles_storage
    ? { ...JSON.parse(user_profiles_storage) }
    : {};

  if (!email || !user_profiles[email]) return;

  const { token, refresh_token } = user_profiles[email];

  dispatch({
    type: LOGIN_USER,
    payload: {
      data: user_profiles[email],
      token,
      refresh_token,
    },
  });
};

export const setSidebarCollapsed = (status) => (dispatch) => {
  dispatch({
    type: TOGGLE_SIDEBAR,
    payload: status,
  });
};

export const getDraftComments = async (brand, draftId) => {
  if (!draftId) return;
  try {
    const res = await axiosInstance.get(
      `brand/${brand?.id}/drafts/${draftId}/comments`
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const getInvites = async () => {
  const activeAccount = store.getState().active_account;
  if (!activeAccount) return;

  const planName = activeAccount.current_subscription.plan_name;

  if (["free", "essential"].includes(planName)) {
    return;
  }
  try {
    const res = await axiosInstance.get(`account/${activeAccount.id}/invite`);
    store.dispatch({
      type: GET_INVITES,
      payload: res.data.data,
    });
  } catch (e) {
    store.dispatch({
      type: GET_INVITES,
      payload: [],
    });
  }
};

export const getMember = async () => {
  const activeAccount = store.getState().active_account;
  const user = store.getState().user;

  try {
    const res = await axiosInstance.get(
      `account/${activeAccount.id}/team/${user.id}`
    );
    if (res.data.status === true) {
      const data = res.data.data;
      store.dispatch({
        type: SET_MEMBER,
        payload: data,
      });
    }
  } catch (err) {
    store.dispatch({
      type: SET_MEMBER,
      payload: null,
    });
  }
};

export const getMembers = async () => {
  const activeAccount = store.getState().active_account;
  const planName = activeAccount?.current_subscription.plan_name;

  if (["free", "essential"].includes(planName)) {
    return;
  }

  try {
    const res = await axiosInstance.get(`account/${activeAccount.id}/team`);

    if (res?.data?.status === true) {
      store.dispatch({
        type: GET_MEMBERS,
        payload: res.data.data.users,
      });
    }
  } catch (error) {
    store.dispatch({
      type: GET_MEMBERS,
      payload: [],
    });
  }
};
